import { ScorecardAvailability } from './scorecard-availability-dto';
import { ScorecardPromotionalActivity } from './scorecard-promotional-activity-dto';
import { ScorecardStatsDto } from './scorecard-stats-dto';

export class ScorecardDto {
    constructor(
        public emiItemId: number,
        public startDate: Date,
        public endDate: Date,
        public price: ScorecardStatsDto,
        public rating: ScorecardStatsDto,
        public promotionalActivity: ScorecardPromotionalActivity,
        public availability: ScorecardAvailability
    ) { }
}
